import { useSyncExternalStore } from 'react';

// Whether this window is showing routine mode (the overlay). Leaving it pauses the run; the pill brings it back.
let open = false;
const subs = new Set();
const emit = () => subs.forEach((f) => f());

export const openRoutineMode = () => { open = true; emit(); };
export const closeRoutineMode = () => { open = false; emit(); };
export const useRoutineModeOpen = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => open);
